import React from 'react';
import Grid, { GridProps } from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import clsx from 'clsx';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Typography from '@material-ui/core/Typography';

const SubjectGrid: React.FC<GridProps> = withStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    width: '100%',
    '&:hover': {
      color: theme.palette.text.secondary,
      textDecoration: 'none',
      opacity: 0.6,
    },
    [theme.breakpoints.down(768)]: {
      marginTop: '.5rem',
    },
  },
  subject: {
    color: '#333333',
    marginLeft: 20,
    [theme.breakpoints.down(768)]: {
      marginLeft: 0,
    },
  },
  arrow: {
    color: theme.palette.primary.main,
    marginLeft: 'auto',
  },
}))(({ classes, children, ...props }) => {
  return (
    <Grid {...props} className={classes.root}>
      <Typography
        component="span"
        className={clsx(classes.subject, 'line-truncate-2')}
      >
        {children}
      </Typography>
      <ChevronRightIcon className={classes.arrow} />
    </Grid>
  );
});

export default SubjectGrid;
